import React, { useCallback, useEffect, useRef, useState } from "react";
import {
  useNavigate,
  useSearchParams,
  createSearchParams,
} from "react-router-dom";
import FiltersPanel from "./filtersPanel";
import SystemSummaryPannel from "./systemSummaryPanel";
import CircularMetricsPanel from "./circularMetricsPanel";
import UtilizationPanel from "./utilizationPanel";
import { Container, Section, Title } from "./styles";
import { useHeader } from "components/header/store";
import InstanceAction from "components/instanceAction";
import { getTaskData } from "api/taskStatus";
import { instanceAPI } from "api";

const getISOStringForInput = (date: Date) => {
  const pad = (n: number) => n.toString().padStart(2, "0");
  const yyyy = date.getFullYear();
  const MM = pad(date.getMonth() + 1);
  const dd = pad(date.getDate());
  const hh = pad(date.getHours());
  const mm = pad(date.getMinutes());
  return `${yyyy}-${MM}-${dd}T${hh}:${mm}`;
};

const Metric = () => {
  const { setTitle, setButtons } = useHeader();
  useEffect(() => {
    setTitle("METRIC");
    setButtons(null);
  }, [setTitle, setButtons]);

  const [searchParams, setSearchParams] = useSearchParams();
  const vdiName = searchParams.get("name");
  const [startTime, setStartTime] = useState("");
  const [endTime, setEndTime] = useState("");

  const navigate = useNavigate();

  const getFirstInstance = useCallback(async () => {
    try {
      const instanceList = (await getTaskData(instanceAPI.getInstnaceList))
        .result.data;

      if (instanceList.length) {
        navigate(
          {
            pathname: "/metric",
            search: `?${createSearchParams({ name: instanceList[0] })}`,
          },
          { replace: true }
        );
      } else {
      }
    } catch {}
  }, [navigate]);

  const triedRef = useRef(false);
  useEffect(() => {
    if (!vdiName && !triedRef.current) {
      triedRef.current = true;
      void getFirstInstance();
    }
  }, [vdiName, getFirstInstance]);

  const onChangeInstance = (name: string) => {
    const next = new URLSearchParams(searchParams);
    next.set("name", name);
    setSearchParams(next, { replace: true });
  };

  useEffect(() => {
    const now = new Date();
    const eTime = new Date(now.getTime() - 60 * 1000);
    const oneHourAgo = new Date(now.getTime() - 60 * 60 * 1000);
    setStartTime(getISOStringForInput(oneHourAgo));
    setEndTime(getISOStringForInput(eTime));
  }, [vdiName]);

  if (!vdiName) return;

  return (
    <Container>
      <FiltersPanel
        valueInstance={vdiName}
        onChangeInstance={onChangeInstance}
        start={startTime}
        end={endTime}
        onChangeStart={setStartTime}
        onChangeEnd={setEndTime}
      />

      <Section>
        <Title>Action</Title>
        <InstanceAction selectInstances={[{ name: vdiName }]} />
      </Section>

      <SystemSummaryPannel instance={vdiName || undefined} />
      <CircularMetricsPanel instance={vdiName || undefined} />
      <UtilizationPanel
        selectedNode={vdiName || undefined}
        start={startTime}
        end={endTime}
      />
    </Container>
  );
};

export default Metric;
